import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BotaoDuplo from '../../../Componentes/BotaoDuplo';
import CampoEdicoes, { SubTituloCampoEdicoes } from '../../../Componentes/CampoEdicoes';
import CorpoPagina from '../../../Componentes/CorpoPagina';
import Espaçador from '../../../Componentes/Espaçador';
import ModalConfirmacao from '../../../Componentes/ModalConfirmacao';
import TextInput from '../../../Componentes/TextInput';
import TopicoTexto from '../../../Componentes/TopicoTexto';
import '../../../Estilos/Ambiente.css';
import CheckBoxOpcoes from '../../../Componentes/CheckBoxOpcoes';
import HourPicker from '../../../Componentes/HourPicker';
import NivelCard from '../../../Componentes/NivelCard';
import { apiService } from '../../../Services/ApiService';
import useWindowSize from '../../../Hooks/windowSize';
import { useTranslation } from 'react-i18next';

export default function AmbienteCadastro() {
  const { t } = useTranslation('errors');
  const windowSize = useWindowSize();
  const [isMobile, setIsMobile] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const larguraEspaçador = 16;
  const [modalCancel, setModalCancel] = useState(false);
  const [modalConfirm, setModalConfirm] = useState(false);
  const [modalSuccess, setModalSuccess] = useState(false);
  const [modalError, setModalError] = useState({
    visible: false,
    message: '',
  });
  const navega = useNavigate();
  const [environment, setEnvironment] = useState({
    nomeCadastro: '',
    minTemperatureCadastro: null,
    maxTemperatureCadastro: null,
    minTemperatureOffsetCadastro: null,
    maxTemperatureOffsetCadastro: null,
    minHumidityCadastro: null,
    maxHumidityCadastro: null,
    minHumidityOffsetCadastro: null,
    maxHumidityOffsetCadastro: null,
    minHourCadastro: null,
    maxHourCadastro: null,
    referenceCadastro: '',
    weekdaysCadastro: [],
    escalations: [],
  });

  const [validationErrors, setValidationErrors] = useState({
    nomeCadastro: true,
    minTemperatureCadastro: true,
    maxTemperatureCadastro: true,
    minTemperatureOffsetCadastro: true,
    maxTemperatureOffsetCadastro: true,
    minHumidityCadastro: true,
    maxHumidityCadastro: true,
    minHumidityOffsetCadastro: true,
    maxHumidityOffsetCadastro: true,
    minHourCadastro: true,
    maxHourCadastro: true,
    referenceCadastro: true,
    weekdaysCadastro: true,
    escalations: true,
  });

  const [touchedFields, setTouchedFields] = useState({
    nomeCadastro: false,
    minTemperatureCadastro: false,
    maxTemperatureCadastro: false,
    minTemperatureOffsetCadastro: false,
    maxTemperatureOffsetCadastro: false,
    minHumidityCadastro: false,
    maxHumidityCadastro: false,
    minHumidityOffsetCadastro: false,
    maxHumidityOffsetCadastro: false,
    minHourCadastro: false,
    maxHourCadastro: false,
    referenceCadastro: false,
    weekdaysCadastro: false,
    escalations: false,
  });

  const [daysOfTheWeek, setDaysOfTheWeek] = useState([
    { value: 1, nome: 'Segunda-feira', state: false },
    { value: 2, nome: 'Terça-feira', state: false },
    { value: 3, nome: 'Quarta-feira', state: false },
    { value: 4, nome: 'Quinta-feira', state: false },
    { value: 5, nome: 'Sexta-feira', state: false },
    { value: 6, nome: 'Sábado', state: false },
    { value: 7, nome: 'Domingo', state: false },
  ]);

  const [users, setUsers] = useState([{ value: null, label: 'Desativado' }]);
  const [escalations, setEscalations] = useState([
    {
      priority: 1,
      user: [],
      expiryTime: null,
      notifyTime: null,
      isExpanded: false,
      isValid: false,
    },
    {
      priority: 2,
      user: [],
      expiryTime: null,
      notifyTime: null,
      isExpanded: false,
      isValid: false,
    },
    {
      priority: 3,
      user: [],
      expiryTime: null,
      notifyTime: null,
      isExpanded: false,
      isValid: false,
    },
    {
      priority: 4,
      user: [],
      expiryTime: null,
      notifyTime: null,
      isExpanded: false,
      isValid: false,
    },
    {
      priority: 5,
      user: [],
      expiryTime: null,
      notifyTime: null,
      isExpanded: false,
      isValid: false,
    },
  ]);

  const { id } = useParams();
  const { get, post, put } = apiService();

  useEffect(() => {
    setIsMobile(windowSize.width < 920);
  }, [windowSize]);

  useEffect(() => {
    if (id) {
      getEnvironmentById();
      setIsEditing(true);
    } else {
      setIsEditing(false);
    }

    getUsers();
    setIsLoading(false);
  }, [id]);

  useEffect(() => {
    setIsFormValid(Object.values(validationErrors).every((v) => !v));
  }, [validationErrors, escalations]);

  useEffect(() => {
    Object.entries(environment).forEach(([key, value]) => {
      setAndValidateField(key, value);
    });
    setAndValidateField('escalations', escalations);
  }, [
    environment.nomeCadastro,
    environment.minTemperatureCadastro,
    environment.maxTemperatureCadastro,
    environment.minTemperatureOffsetCadastro,
    environment.maxTemperatureOffsetCadastro,
    environment.minHumidityCadastro,
    environment.maxHumidityCadastro,
    environment.minHumidityOffsetCadastro,
    environment.maxHumidityOffsetCadastro,
    environment.minHourCadastro,
    environment.maxHourCadastro,
    environment.referenceCadastro,
    environment.weekdaysCadastro,
    escalations,
  ]);

  const getEnvironmentById = async () => {
    try {
      setIsLoading(true);
      const environment = await get(`environments/${id}`);
      const selectedWeekdaysIds = environment.weekdays.map((day) => day.id);
      if (environment) {
        setEnvironment({
          nomeCadastro: environment.name,
          minTemperatureCadastro: environment.minTemperature,
          maxTemperatureCadastro: environment.maxTemperature,
          minTemperatureOffsetCadastro: environment.minTemperatureOffset,
          maxTemperatureOffsetCadastro: environment.maxTemperatureOffset,
          minHumidityCadastro: environment.minHumidity,
          maxHumidityCadastro: environment.maxHumidity,
          minHumidityOffsetCadastro: environment.minHumidityOffset,
          maxHumidityOffsetCadastro: environment.maxHumidityOffset,
          minHourCadastro: environment.minHour,
          maxHourCadastro: environment.maxHour,
          referenceCadastro: environment.reference,
        });

        selectedWeekdaysIds.forEach((id) => {
          const day = daysOfTheWeek.find((day) => day.value === id);
          if (day) {
            setDaysOfTheWeek((prev) => {
              return prev.map((d) => {
                if (d.value === day.value) {
                  d.state = true;
                }
                return d;
              });
            });
          }
        });

        if (environment.escalations && environment.escalations.length !== 0) {
          const newEscalations = escalations.map((escalation) => {
            const foundEscalation = environment.escalations.find(
              (e) => e.priority === escalation.priority,
            );
            if (foundEscalation) {
              return {
                priority: escalation.priority,
                user: Array.isArray(foundEscalation.users)
                  ? foundEscalation.users.map((i) => i.id)
                  : [],
                expiryTime: foundEscalation.timePeriodMinutes || null,
                notifyTime: foundEscalation.notifyUserEachMinutes || null,
                isExpanded: false,
                isValid: true,
              };
            }
            return escalation;
          });

          setEscalations(newEscalations);
          setTouchedFields((prev) => ({ ...prev, escalations: true }));
          setValidationErrors((prev) => ({ ...prev, escalations: false }));
        }

        Object.entries(environment).forEach(([key, value]) => {
          if (key !== 'escalations' && key !== 'weekdays') {
            setAndValidateField(key, value);
            setTouchedFields((prev) => ({ ...prev, [key]: true }));
          }
        });
      }
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar ambiente' });
    } finally {
      setIsLoading(false);
    }
  };

  const getUsers = async () => {
    try {
      const existingUsers = await get('users');
      if (existingUsers && existingUsers.result) {
        const formattedUsers = existingUsers.result.map((user) => ({
          value: user.id,
          label: user.name,
        }));
        setUsers(formattedUsers);
      }
    } catch (error) {
      setModalError({ visible: true, message: 'Erro ao buscar usuários' });
    }
  };

  const handleSave = () => {
    setModalConfirm(true);
  };

  const saveEnvironment = async () => {
    if (!isFormValid) {
      return;
    }

    setModalConfirm(false);

    const data = {
      name: environment.nomeCadastro,
      minTemperature: Number(environment.minTemperatureCadastro),
      maxTemperature: Number(environment.maxTemperatureCadastro),
      minTemperatureOffset: Number(environment.minTemperatureOffsetCadastro),
      maxTemperatureOffset: Number(environment.maxTemperatureOffsetCadastro),
      minHumidity: Number(environment.minHumidityCadastro),
      maxHumidity: Number(environment.maxHumidityCadastro),
      minHumidityOffset: Number(environment.minHumidityOffsetCadastro),
      maxHumidityOffset: Number(environment.maxHumidityOffsetCadastro),
      minHour: environment.minHourCadastro,
      maxHour: environment.maxHourCadastro,
      reference: environment.referenceCadastro,
      escalations: escalations
        .filter((item) => item.user.length > 0 && item.expiryTime && item.notifyTime)
        .map((item) => ({
          priority: item.priority,
          timePeriodMinutes: Number(item.expiryTime),
          notifyUserEachMinutes: Number(item.notifyTime),
          user: item.user,
        })),
    };

    const weekdays = daysOfTheWeek
      .map((day) => (day.state ? day.value : null))
      .filter((day) => day !== null);
    data.weekdays = weekdays;

    try {
      setIsLoading(true);
      let response;
      if (id) {
        response = await put(`environments/${id}`, data);
      } else {
        response = await post('environments', data);
      }

      if (response && response.success) {
        setModalSuccess(true);
      } else {
        throw new Error(response.message || 'Erro ao salvar ambiente');
      }
    } catch (error) {
      let errorMessage = 'Erro ao salvar ambiente';
      if (error.message) {
        errorMessage = t(error.message);
      } else if (error.response && error.response.data && error.response.data.message) {
        errorMessage = t(`errors.${error.response.data.message}`);
      }
      setModalError({
        visible: true,
        message: errorMessage,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    setModalCancel(true);
  };

  function timeToMinutes(time) {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  }

  const validators = {
    nomeCadastro: (value) => value && value.trim().length > 0 && value.trim().length <= 100,
    referenceCadastro: (value) => value && value.trim().length > 0 && value.trim().length <= 50,
    minTemperatureCadastro: (value) =>
      value !== null &&
      environment.maxTemperatureCadastro !== null &&
      Number(value) < Number(environment.maxTemperatureCadastro),
    maxTemperatureCadastro: (value) =>
      value !== null &&
      environment.minTemperatureCadastro !== null &&
      Number(value) > Number(environment.minTemperatureCadastro),
    minTemperatureOffsetCadastro: (value) =>
      value && /^(\d+|\d*\.\d+)$/.test(value) && Number(value) >= 0,
    maxTemperatureOffsetCadastro: (value) =>
      value && /^(\d+|\d*\.\d+)$/.test(value) && Number(value) >= 0,
    minHumidityCadastro: (value) =>
      value !== null &&
      Number(value) >= 0 &&
      Number(value) <= 100 &&
      environment.maxHumidityCadastro !== null &&
      Number(value) < Number(environment.maxHumidityCadastro),
    maxHumidityCadastro: (value) =>
      value !== null &&
      Number(value) >= 0 &&
      Number(value) <= 100 &&
      environment.minHumidityCadastro !== null &&
      Number(value) > Number(environment.minHumidityCadastro),
    minHumidityOffsetCadastro: (value) =>
      Number(value) && /^(\d+|\d*\.\d+)$/.test(value) && Number(value) >= 0,
    maxHumidityOffsetCadastro: (value) =>
      Number(value) && /^(\d+|\d*\.\d+)$/.test(value) && Number(value) >= 0,
    minHourCadastro: (value) =>
      value &&
      value !== null &&
      environment.maxHourCadastro &&
      timeToMinutes(value) !== timeToMinutes(environment.maxHourCadastro),
    maxHourCadastro: (value) =>
      value &&
      value !== null &&
      environment.minHourCadastro &&
      timeToMinutes(value) !== timeToMinutes(environment.minHourCadastro),
    escalations: (escalations) => {
      return escalations.every((item) => {
        if (
          item.expiryTime &&
          item.notifyTime &&
          Array.isArray(item.user) &&
          item.user.length > 0
        ) {
          item.isValid = Number(item.expiryTime) >= Number(item.notifyTime);
          return Number(item.expiryTime) >= Number(item.notifyTime);
        } else if (
          item.priority > 1 &&
          !item.expiryTime &&
          !item.notifyTime &&
          Array.isArray(item.user) &&
          item.user.length === 0
        ) {
          item.isValid = true;
          return true;
        } else if (
          item.priority > 1 &&
          ((item.expiryTime && item.notifyTime) ||
            (Array.isArray(item.user) && item.user.length === 0))
        ) {
          item.isValid = true;
          return true;
        } else {
          item.isValid = false;
          return false;
        }
      });
    },
  };

  const validateField = (name, value) => {
    return validators[name] ? validators[name](value) : true;
  };

  const setAndValidateField = (name, value) => {
    if (
      name === 'minTemperatureOffsetCadastro' &&
      value &&
      environment.minTemperatureCadastro &&
      environment.maxTemperatureCadastro
    ) {
      const midTemperature =
        (Number(environment.minTemperatureCadastro) + Number(environment.maxTemperatureCadastro)) /
        2;
      if (Number(environment.minTemperatureCadastro) + Number(value) >= midTemperature) {
        setValidationErrors((prev) => ({ ...prev, [name]: true }));
        return;
      }
    } else if (
      name === 'maxTemperatureOffsetCadastro' &&
      value &&
      environment.minTemperatureCadastro &&
      environment.maxTemperatureCadastro
    ) {
      const midTemperature =
        (Number(environment.minTemperatureCadastro) + Number(environment.maxTemperatureCadastro)) /
        2;
      if (Number(environment.maxTemperatureCadastro) - Number(value) <= midTemperature) {
        setValidationErrors((prev) => ({ ...prev, [name]: true }));
        return;
      }
    } else if (
      name === 'minHumidityOffsetCadastro' &&
      value &&
      environment.minHumidityCadastro &&
      environment.maxHumidityCadastro
    ) {
      const midHumidity =
        (Number(environment.minHumidityCadastro) + Number(environment.maxHumidityCadastro)) / 2;
      if (Number(environment.minHumidityCadastro) + Number(value) >= midHumidity) {
        setValidationErrors((prev) => ({ ...prev, [name]: true }));
        return;
      }
    } else if (
      name === 'maxHumidityOffsetCadastro' &&
      value &&
      environment.minHumidityCadastro &&
      environment.maxHumidityCadastro
    ) {
      const midHumidity =
        (Number(environment.minHumidityCadastro) + Number(environment.maxHumidityCadastro)) / 2;
      if (Number(environment.maxHumidityCadastro) - Number(value) <= midHumidity) {
        setValidationErrors((prev) => ({ ...prev, [name]: true }));
        return;
      }
    }

    const isValid = validateField(name, value);
    setValidationErrors((prev) => ({ ...prev, [name]: !isValid }));
  };

  const handleChange = (name, value) => {
    setEnvironment({ ...environment, [name]: value });
    setTouchedFields((prev) => ({ ...prev, [name]: true }));
    setAndValidateField(name, value);
  };

  const handleCheckBoxChange = (value) => {
    const updatedCycle = daysOfTheWeek.map((item) => {
      if (item.value === value) {
        return { ...item, state: !item.state };
      }
      return item;
    });

    setDaysOfTheWeek(updatedCycle);
  };

  const handleEscalationMenuClicked = (priority) => {
    return () => {
      const updatedEscalation = escalations.map((item) => {
        if (item.priority === priority) {
          return { ...item, isExpanded: !item.isExpanded };
        }
        return { ...item, isExpanded: false };
      });

      setEscalations(updatedEscalation);
    };
  };

  const handleEscalationChanges = (priority, type, value) => {
    const updatedEscalation = escalations.map((item) => {
      if (item.priority === priority) {
        if (type === 'user') {
          const userIds = value.map((user) => user.value);
          return { ...item, user: userIds };
        }
        return { ...item, [type]: value };
      }
      return item;
    });

    setEscalations(updatedEscalation);
    setTouchedFields((prev) => ({ ...prev, escalations: true }));
  };

  return (
    <CorpoPagina loading={isLoading}>
      {modalCancel && (
        <ModalConfirmacao
          aviso="Deseja realmente cancelar?"
          confirmar={false}
          clicado={() => navega(-1)}
          clicadoVolta={() => setModalCancel(false)}
        />
      )}
      {modalSuccess && (
        <ModalConfirmacao
          aviso="Ambiente salvo com sucesso!"
          confirmar={true}
          clicado={() => navega(-1)}
        />
      )}
      {modalConfirm && (
        <ModalConfirmacao
          aviso="Deseja realmente salvar o ambiente?"
          confirmar={false}
          clicado={saveEnvironment}
          clicadoVolta={() => setModalConfirm(false)}
        />
      )}
      {modalError.visible && (
        <ModalConfirmacao
          aviso={modalError.message}
          erro={true}
          clicado={() => setModalError({ visible: false, message: '' })}
        />
      )}
      <div className="ContainerGeral">
        {!isEditing && <TopicoTexto titulo="Cadastrar Ambiente" />}
        {isEditing && <TopicoTexto titulo="Editar Ambiente" />}
        <div className="AmbienteView">
          <CampoEdicoes
            titulo="AMBIENTE"
            maxW={isMobile ? '-webkit-fill-available' : '540px'}
            width={isMobile ? '100%' : '100vw'}
            height="50%"
          >
            <div
              style={{
                width: '90%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
              }}
            >
              <TextInput
                titulo="Nome"
                padrao={environment.nomeCadastro}
                placeholder="Insira o nome"
                tipo="input"
                largura="90%"
                top={15}
                onUpdate={(txt) => handleChange('nomeCadastro', txt)}
                erro={validationErrors.nomeCadastro && touchedFields.nomeCadastro}
                erroTexto="Nome inválido"
                maxLength={100}
              />
            </div>
            <div
              style={{
                width: '90%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                paddingBottom: '40px',
              }}
            >
              <TextInput
                titulo="Documento de referência"
                padrao={environment.referenceCadastro}
                placeholder="Insira referência"
                tipo="input"
                largura="90%"
                top={15}
                onUpdate={(txt) => handleChange('referenceCadastro', txt)}
                erro={validationErrors.referenceCadastro && touchedFields.referenceCadastro}
                erroTexto="Referência inválida"
                maxLength={50}
              />
            </div>
          </CampoEdicoes>

          <CampoEdicoes
            titulo="PARÂMETROS"
            maxH={1000}
            maxW={isMobile ? '-webkit-fill-available' : '540px'}
            width={isMobile ? '100%' : '100vw'}
            height={isMobile ? 1100 : 800}
          >
            <SubTituloCampoEdicoes nome="TEMPERATURA (°C)" />
            <SubTituloCampoEdicoes nome="PARÂMETROS DENTRO DO PADRÃO" />
            <div
              style={
                isMobile
                  ? {
                      width: '90%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                    }
                  : {
                      width: '90%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-start',
                      paddingLeft: '10px',
                      paddingRight: '10px',
                    }
              }
            >
              <TextInput
                titulo="Mínimo"
                padrao={environment.minTemperatureCadastro}
                placeholder="Temp. mín."
                tipo="number"
                largura="90%"
                onUpdate={(value) => handleChange('minTemperatureCadastro', value)}
                erro={
                  touchedFields.minTemperatureCadastro && validationErrors.minTemperatureCadastro
                }
                erroTexto="Valor maior que máximo"
              />
              <Espaçador espaço={larguraEspaçador} />
              <TextInput
                titulo="Máximo"
                padrao={environment.maxTemperatureCadastro}
                placeholder="Temp. máx."
                tipo="number"
                largura="90%"
                onUpdate={(value) => handleChange('maxTemperatureCadastro', value)}
                erro={
                  touchedFields.maxTemperatureCadastro && validationErrors.maxTemperatureCadastro
                }
                erroTexto="Valor menor que mínimo"
              />
            </div>
            <SubTituloCampoEdicoes nome="OFFSET DE ATENÇÃO" />
            <div
              style={
                isMobile
                  ? {
                      width: '90%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                    }
                  : {
                      width: '90%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-start',
                      paddingLeft: '10px',
                      paddingRight: '10px',
                    }
              }
            >
              <TextInput
                titulo="Mínimo"
                padrao={environment.minTemperatureOffsetCadastro}
                placeholder="Offset mín."
                tipo="number"
                largura="90%"
                onUpdate={(txt) => handleChange('minTemperatureOffsetCadastro', txt)}
                erro={
                  validationErrors.minTemperatureOffsetCadastro &&
                  touchedFields.minTemperatureOffsetCadastro
                }
                erroTexto="Offset inválido"
                minValue={0}
              />
              <Espaçador espaço={larguraEspaçador} />
              <TextInput
                titulo="Máximo"
                padrao={environment.maxTemperatureOffsetCadastro}
                placeholder="Offset máx."
                tipo="number"
                largura="90%"
                onUpdate={(txt) => handleChange('maxTemperatureOffsetCadastro', txt)}
                erro={
                  validationErrors.maxTemperatureOffsetCadastro &&
                  touchedFields.maxTemperatureOffsetCadastro
                }
                erroTexto="Offset inválido"
                minValue={0}
              />
            </div>
            <SubTituloCampoEdicoes nome="UMIDADE (%)" top={32} />
            <SubTituloCampoEdicoes nome="PARÂMETROS DENTRO DO PADRÃO" />
            <div
              style={
                isMobile
                  ? {
                      width: '90%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                    }
                  : {
                      width: '90%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-start',
                      paddingLeft: '10px',
                      paddingRight: '10px',
                    }
              }
            >
              <TextInput
                titulo="Mínimo"
                padrao={environment.minHumidityCadastro}
                placeholder="Umid. mín."
                tipo="number"
                largura="90%"
                onUpdate={(txt) => handleChange('minHumidityCadastro', txt)}
                erro={validationErrors.minHumidityCadastro && touchedFields.minHumidityCadastro}
                erroTexto="Valor maior que máximo"
                minValue={0}
                maxValue={100}
              />
              <Espaçador espaço={larguraEspaçador} />
              <TextInput
                titulo="Máximo"
                padrao={environment.maxHumidityCadastro}
                placeholder="Umid. máx."
                tipo="number"
                largura="90%"
                onUpdate={(txt) => handleChange('maxHumidityCadastro', txt)}
                erro={validationErrors.maxHumidityCadastro && touchedFields.maxHumidityCadastro}
                erroTexto="Valor menor que mínimo"
                minValue={0}
                maxValue={100}
              />
            </div>
            <SubTituloCampoEdicoes nome="OFFSET DE ATENÇÃO" />
            <div
              style={
                isMobile
                  ? {
                      width: '90%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'flex-start',
                    }
                  : {
                      width: '90%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'flex-start',
                      paddingLeft: '10px',
                      paddingRight: '10px',
                    }
              }
            >
              <TextInput
                titulo="Mínimo"
                padrao={environment.minHumidityOffsetCadastro}
                placeholder="Offset mín."
                tipo="number"
                largura="90%"
                onUpdate={(txt) => handleChange('minHumidityOffsetCadastro', txt)}
                erro={
                  validationErrors.minHumidityOffsetCadastro &&
                  touchedFields.minHumidityOffsetCadastro
                }
                erroTexto="Offset inválido"
                minValue={0}
                maxValue={100}
              />
              <Espaçador espaço={larguraEspaçador} />
              <TextInput
                titulo="Máximo"
                padrao={environment.maxHumidityOffsetCadastro}
                placeholder="Offset máx."
                tipo="number"
                largura="90%"
                onUpdate={(txt) => handleChange('maxHumidityOffsetCadastro', txt)}
                erro={
                  validationErrors.maxHumidityOffsetCadastro &&
                  touchedFields.maxHumidityOffsetCadastro
                }
                erroTexto="Offset inválido"
                minValue={0}
                maxValue={100}
              />
            </div>
          </CampoEdicoes>

          <div className="AmbienteSubViewSecond">
            <CampoEdicoes
              titulo="HORÁRIO DE ANÁLISE"
              maxH={'fit-content'}
              maxW={isMobile ? '-webkit-fill-available' : '540px'}
              width={'100%'}
              height={'fit-content'}
            >
              <div
                style={
                  !isMobile
                    ? {
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        paddingLeft: '26px',
                        paddingRight: '10px',
                        marginTop: '10px',
                      }
                    : {
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        paddingLeft: '26px',
                        paddingRight: '10px',
                        marginTop: '10px',
                      }
                }
                className="HourModal"
              >
                <HourPicker
                  titulo="Insira o período"
                  minValue={environment.minHourCadastro}
                  maxValue={environment.maxHourCadastro}
                  minValueChanged={(txt) => handleChange('minHourCadastro', txt)}
                  maxValueChanged={(txt) => handleChange('maxHourCadastro', txt)}
                  erro={
                    (validationErrors.minHourCadastro && touchedFields.minHourCadastro) ||
                    (validationErrors.maxHourCadastro && touchedFields.maxHourCadastro)
                  }
                  erroTexto="Horário inválido"
                />
                <div
                  className="WeekView"
                  style={{
                    marginBottom:
                      (validationErrors.maxHourCadastro && touchedFields.maxHourCadastro) ||
                      (validationErrors.minHourCadastro && touchedFields.minHourCadastro)
                        ? '27px'
                        : '0',
                  }}
                >
                  <CheckBoxOpcoes
                    titulo="Selecione os dias"
                    items={daysOfTheWeek}
                    top={8}
                    width="92%"
                    altura={'fit-content'}
                    clicado={(txt) => handleCheckBoxChange(txt)}
                  />
                </div>
              </div>
            </CampoEdicoes>
            <CampoEdicoes
              titulo="FLUXO DE ESCALAÇÃO"
              maxH={'fit-content'}
              maxW={isMobile ? '-webkit-fill-available' : '540px'}
              width={'100%'}
              height={'fit-content'}
              marginTop={0}
            >
              <div class="LevelView">
                {escalations.map((escalation) => (
                  <NivelCard
                    key={escalation.priority}
                    titulo={`Nível ${escalation.priority}`}
                    expanded={escalation.isExpanded}
                    menu_clicked={handleEscalationMenuClicked(escalation.priority)}
                    expiryTime={escalation.expiryTime}
                    notifyTime={escalation.notifyTime}
                    responsible={
                      Array.isArray(escalation.user)
                        ? escalation.user
                            .map((userId) => users.find((user) => user.value === userId))
                            .filter(Boolean)
                        : []
                    }
                    items={escalations}
                    users={users ? users : []}
                    changes={(type, value) => {
                      handleEscalationChanges(escalation.priority, type, value);
                    }}
                    largura={'50%'}
                    disabled={!users || users.length === 0}
                    erro={!escalation.isValid && touchedFields.escalations}
                    erroTexto={'Valores não permitidos'}
                  />
                ))}
              </div>
            </CampoEdicoes>
          </div>
        </div>

        <div
          style={
            isMobile
              ? {
                  display: 'flex',
                  height: 200,
                  marginTop:
                    validationErrors.minHourCadastro ||
                    validationErrors.maxHourCadastro ||
                    validationErrors.minHumidityCadastro ||
                    validationErrors.maxHumidityCadastro ||
                    validationErrors.minTemperatureCadastro ||
                    validationErrors.maxTemperatureCadastro ||
                    validationErrors.referenceCadastro ||
                    validationErrors.nomeCadastro ||
                    validationErrors.offsetHumidityCadastro ||
                    validationErrors.offsetHumidityCadastro
                      ? 1750
                      : 1800,
                }
              : { display: 'flex', height: 200, marginTop: 60 }
          }
        >
          <BotaoDuplo
            nome="Salvar"
            nomeVolta="Cancelar"
            top={16}
            bottom={32}
            clicado={handleSave}
            clicadoVolta={handleCancel}
            externo={true}
            disabled={!isFormValid}
          />
        </div>
      </div>
    </CorpoPagina>
  );
}
